var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "client-profiles-page",
      attrs: { id: "single-referrer-details-page" },
    },
    [
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center" },
            [
              _c(
                "b-col",
                {
                  staticClass: "form-page px-md-5 client pb-5",
                  attrs: { cols: "12" },
                },
                [
                  _c("referrer-details-header", {
                    attrs: {
                      referrer: _vm.localReferrer,
                      "referrer-id": _vm.referrerId,
                      saving: _vm.saving,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "col-lg client-profile-sidebar",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("referrer-details", {
                                    attrs: {
                                      loading: _vm.loading,
                                      referrer: _vm.localReferrer,
                                    },
                                    on: { "update:referrer": _vm.handleSave },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("referrer-custom-fields", {
                                    attrs: {
                                      referrer: _vm.localReferrer,
                                      "referrer-id": _vm.referrerId,
                                    },
                                    on: { "update:referrer": _vm.handleSave },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("referrer-linked-apps", {
                                    attrs: {
                                      "referrer-id": _vm.referrerId,
                                      applications: _vm.applications,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("referrer-linked-profiles", {
                                    attrs: {
                                      "referrer-id": _vm.referrerId,
                                      profiles: _vm.profiles,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("referrer-actions-panel", {
                                    attrs: {
                                      loading: _vm.loading,
                                      "current-tab": _vm.currentActionPanelTab,
                                      referrer: _vm.localReferrer,
                                      "referrer-id": _vm.referrerId,
                                    },
                                    on: {
                                      tab: _vm.changeActionPanelTab,
                                      submit: _vm.loadChangelog,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("referrer-timeline-container", {
                                attrs: {
                                  "referrer-id": _vm.referrerId,
                                  "timeline-tab": _vm.timelineTab,
                                  "loading-changelog": _vm.loadingChangelog,
                                },
                                on: {
                                  "update:timelineTab": function ($event) {
                                    _vm.timelineTab = $event
                                  },
                                  "update:timeline-tab": function ($event) {
                                    _vm.timelineTab = $event
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }